<template>
  <div class="page-calendrier">
    <landing-header />
    <main>

      <!-- HERO -->
      <section class="hero-cal">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-cal">Calendrier de réservation</span>
            <h1 class="hero-title">
              Vos clients réservent eux-mêmes.<br/>
              <span class="gradient-text-cal">Vous planifiez en 1 clic.</span>
            </h1>
            <p class="hero-sub">Le client choisit son créneau, renseigne son appareil et son adresse — sans appeler votre bureau. Termoflow vous notifie et planifie l'intervention automatiquement.</p>
            <div class="hero-ctas">
              <a href="/contact"><button class="btn-primary-cal">Demander une démo</button></a>
              <a href="#apercu" class="btn-outline-large">Voir l'aperçu</a>
            </div>
            <div class="hero-stats">
              <div class="stat-pill"><span class="sv">0</span><span class="sl">Saisie manuelle</span></div>
              <div class="stat-pill"><span class="sv">100%</span><span class="sl">Personnalisable</span></div>
              <div class="stat-pill"><span class="sv">Auto</span><span class="sl">Accusés &amp; confirmations</span></div>
            </div>
          </div>
          <div class="lg:w-1/2 w-full" id="apercu">
            <!-- Calendrier mockup -->
            <div class="cal-ui">
              <div class="cal-ui-bar">
                <span class="cal-logo"><i class="fa-solid fa-fire-burner"></i> Thermopro Services</span>
                <span class="cal-ui-sub">Prenez rendez-vous en ligne</span>
              </div>
              <div class="cal-ui-body">
                <div class="cal-steps">
                  <div class="cs cs-done"><div class="cs-num">✓</div><span>Appareil</span></div>
                  <div class="cs-line done-line"></div>
                  <div class="cs cs-done"><div class="cs-num">✓</div><span>Adresse</span></div>
                  <div class="cs-line done-line"></div>
                  <div class="cs cs-active"><div class="cs-num">3</div><span>Créneau</span></div>
                  <div class="cs-line"></div>
                  <div class="cs"><div class="cs-num">4</div><span>Confirmation</span></div>
                </div>
                <div class="cal-main">
                  <div class="cal-left">
                    <div class="cal-month-nav">
                      <button class="cmn-btn"><i class="fa-solid fa-chevron-left"></i></button>
                      <span>Mai 2025</span>
                      <button class="cmn-btn"><i class="fa-solid fa-chevron-right"></i></button>
                    </div>
                    <div class="cal-grid">
                      <div class="cg-day-head" v-for="d in ['L','M','M','J','V','S','D']" :key="d">{{d}}</div>
                      <div class="cg-day empty"></div>
                      <div class="cg-day empty"></div>
                      <div class="cg-day empty"></div>
                      <div class="cg-day">1</div>
                      <div class="cg-day">2</div>
                      <div class="cg-day disabled">3</div>
                      <div class="cg-day disabled">4</div>
                      <div class="cg-day">5</div>
                      <div class="cg-day">6</div>
                      <div class="cg-day">7</div>
                      <div class="cg-day">8</div>
                      <div class="cg-day">9</div>
                      <div class="cg-day disabled">10</div>
                      <div class="cg-day disabled">11</div>
                      <div class="cg-day">12</div>
                      <div class="cg-day">13</div>
                      <div class="cg-day">14</div>
                      <div class="cg-day">15</div>
                      <div class="cg-day selected">16</div>
                      <div class="cg-day disabled">17</div>
                      <div class="cg-day disabled">18</div>
                      <div class="cg-day">19</div>
                      <div class="cg-day">20</div>
                      <div class="cg-day">21</div>
                      <div class="cg-day">22</div>
                      <div class="cg-day">23</div>
                    </div>
                  </div>
                  <div class="cal-right">
                    <div class="cr-label">Vendredi 16 mai</div>
                    <div class="cr-slots">
                      <div class="cr-slot available"><div class="slot-time">Matin<small>8h00 – 12h00</small></div><span class="slot-badge avail">Disponible</span></div>
                      <div class="cr-slot selected-slot"><div class="slot-time">Après-midi<small>14h00 – 18h00</small></div><span class="slot-badge sel-badge">✓ Choisi</span></div>
                    </div>
                    <div class="cr-recap">
                      <div class="recap-row"><i class="fa-solid fa-fire-burner"></i>Chaudière VIESSMAN 24kW</div>
                      <div class="recap-row"><i class="fa-solid fa-wrench"></i>Entretien annuel</div>
                      <div class="recap-row"><i class="fa-solid fa-location-dot"></i>12 rue des Marronniers, Lyon</div>
                    </div>
                    <button class="cal-confirm-btn">Confirmer le rendez-vous <i class="fa-solid fa-arrow-right"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TRUST BAR -->
      <section class="trust-bar">
        <div class="max-w-7xl mx-auto px-4">
          <div class="trust-items">
            <div class="trust-item"><i class="fa-solid fa-user-plus"></i><span>Client s'enregistre lui-même</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-envelope"></i><span>Accusés &amp; confirmations auto</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-paintbrush"></i><span>Personnalisable à 100%</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-calendar-check"></i><span>Planification en 1 clic</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-bell"></i><span>Alerte email instantanée</span></div>
          </div>
        </div>
      </section>

      <!-- PARCOURS CLIENT -->
      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4 text-center">
          <div class="section-label-cal">Parcours client</div>
          <h2 class="section-title">Le client réserve en 4 étapes simples.<br/>Sans vous appeler.</h2>
          <p class="section-sub mx-auto mb-16">Chaque étape est pensée pour être rapide, mobile-friendly et sans friction.</p>
          <div class="steps-flow">
            <div class="step-card">
              <div class="step-num">1</div>
              <div class="step-icon"><i class="fa-solid fa-fire-burner"></i></div>
              <h3>Il décrit son appareil</h3>
              <p>Type d'équipement (chaudière, clim, PAC...), marque, modèle, année. Termoflow propose les choix selon ce que vous avez activé dans vos paramètres.</p>
            </div>
            <div class="step-arrow"><i class="fa-solid fa-arrow-right"></i></div>
            <div class="step-card">
              <div class="step-num">2</div>
              <div class="step-icon"><i class="fa-solid fa-location-dot"></i></div>
              <h3>Il renseigne son adresse</h3>
              <p>Adresse complète avec autocomplétion. Il s'enregistre (nom, email, téléphone) — son profil est créé automatiquement dans votre base clients.</p>
            </div>
            <div class="step-arrow"><i class="fa-solid fa-arrow-right"></i></div>
            <div class="step-card">
              <div class="step-num">3</div>
              <div class="step-icon"><i class="fa-solid fa-calendar-days"></i></div>
              <h3>Il choisit son créneau</h3>
              <p>Il voit uniquement les créneaux que vous avez rendus disponibles. Demi-journée ou créneau précis, selon votre configuration.</p>
            </div>
            <div class="step-arrow"><i class="fa-solid fa-arrow-right"></i></div>
            <div class="step-card">
              <div class="step-num">4</div>
              <div class="step-icon"><i class="fa-solid fa-circle-check"></i></div>
              <h3>Confirmation automatique</h3>
              <p>Il reçoit un accusé de réception immédiat, puis un email de confirmation. Vous êtes notifié en temps réel pour planifier.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- FONCTIONNALITÉS DÉTAILLÉES -->
      <section class="py-24 bg-gray-50 border-y border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="section-label-cal">Pour vous, gérant ou secrétaire</div>
          <h2 class="section-title">De la réservation à la planification,<br/>en quelques secondes</h2>
          <p class="section-sub mb-14">Quand un client réserve, vous avez le choix : planifier directement ou lui proposer plusieurs créneaux alternatifs pour qu'il choisisse.</p>
          <div class="feats-2col">
            <div class="feat2">
              <div class="f2-icon"><i class="fa-solid fa-bolt"></i></div>
              <h3>Planification directe en 1 clic</h3>
              <p>Termoflow vous notifie par email dès qu'un créneau est réservé. Depuis la notification, cliquez "Planifier" : l'intervention est créée avec toutes les informations du client, sans rien ressaisir.</p>
            </div>
            <div class="feat2">
              <div class="f2-icon"><i class="fa-solid fa-list-check"></i></div>
              <h3>Proposer plusieurs créneaux alternatifs</h3>
              <p>Vous préférez vérifier votre planning d'abord ? Sélectionnez 2 ou 3 créneaux disponibles et envoyez-les au client en un clic. Il choisit celui qui lui convient — Termoflow planifie automatiquement.</p>
            </div>
            <div class="feat2">
              <div class="f2-icon"><i class="fa-solid fa-envelope"></i></div>
              <h3>Emails automatiques à chaque étape</h3>
              <p>Accusé de réception à la réservation, email de confirmation une fois planifié, rappel SMS la veille — le client est informé à chaque étape sans que vous leviez le petit doigt.</p>
            </div>
            <div class="feat2">
              <div class="f2-icon"><i class="fa-solid fa-bell"></i></div>
              <h3>Alerte email instantanée</h3>
              <p>Vous recevez une notification email dès qu'un créneau est réservé, avec toutes les informations : client, appareil, adresse, type d'intervention demandé.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION PERSONNALISATION -->
      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row gap-16 items-center">
            <div class="lg:w-1/2">
              <div class="section-label-cal">Personnalisation</div>
              <h2 class="section-title">Votre couleur, votre logo,<br/>votre texte — votre calendrier</h2>
              <p class="section-sub mb-10">Le calendrier de réservation est intégrable sur votre site aux couleurs de votre entreprise. Vos clients ne voient pas Termoflow — ils voient vous.</p>
              <div class="perso-items">
                <div class="pi"><i class="fa-solid fa-check"></i><span><b>Couleurs &amp; logo</b> — votre charte graphique appliquée en un clic</span></div>
                <div class="pi"><i class="fa-solid fa-check"></i><span><b>Texte d'accueil</b> — personnalisez le message de bienvenue</span></div>
                <div class="pi"><i class="fa-solid fa-check"></i><span><b>Types d'interventions</b> — choisissez ce que vous proposez</span></div>
                <div class="pi"><i class="fa-solid fa-check"></i><span><b>Créneaux disponibles</b> — bloquez des périodes, gérez vos absences</span></div>
                <div class="pi"><i class="fa-solid fa-check"></i><span><b>Zone géographique</b> — limitez les réservations à votre zone d'intervention</span></div>
                <div class="pi"><i class="fa-solid fa-check"></i><span><b>Emails automatiques</b> — personnalisez les objets et contenus</span></div>
              </div>
            </div>
            <div class="lg:w-1/2">
              <div class="perso-preview">
                <div class="pp-bar">
                  <span>Aperçu personnalisation</span>
                  <div class="pp-color-swatches">
                    <span class="pp-swatch active-swatch" style="background:#f97316;"></span>
                    <span class="pp-swatch" style="background:#f97316;"></span>
                    <span class="pp-swatch" style="background:#16a34a;"></span>
                    <span class="pp-swatch" style="background:#7c3aed;"></span>
                  </div>
                </div>
                <div class="pp-preview">
                  <div class="pp-header" style="background:#f97316;">
                    <div class="pp-logo-area"><i class="fa-solid fa-fire-burner"></i> Thermopro Services</div>
                    <div class="pp-tagline">Prenez rendez-vous en ligne</div>
                  </div>
                  <div class="pp-body">
                    <div class="pp-welcome">Bonjour ! Quel type d'intervention souhaitez-vous ?</div>
                    <div class="pp-types">
                      <div class="pp-type selected-type">Entretien annuel</div>
                      <div class="pp-type">Dépannage</div>
                      <div class="pp-type">Installation</div>
                      <div class="pp-type">Diagnostic</div>
                    </div>
                    <div class="pp-next" style="background:#f97316;">Suivant →</div>
                  </div>
                </div>
                <div class="pp-note"><i class="fa-solid fa-info-circle"></i> Les clients ne voient jamais "Termoflow" — ils voient votre marque.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-24 text-center bg-gray-900">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-white mb-6">Activez votre calendrier de réservation aujourd'hui</h2>
          <p class="text-xl text-slate-400 mb-10">Vos clients réservent 24h/24, 7j/7 — même quand vous êtes sur un chantier.</p>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/contact"><button class="btn-primary-large-cal">Demander une démonstration</button></a>
            <a href="/planification" class="btn-outline-dark">← Retour au planning</a>
          </div>
        </div>
      </section>

      <landing-roi /><landing-avis />
    </main>
    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'
export default {
  name: 'CalendrierReservationPage',
  components: { LandingHeader, LandingFooter, LandingAvis, 'landing-roi': LandingROI }
}
</script>

<style scoped>
.gradient-text-cal{background:linear-gradient(to right,#f97316,#c91d1d);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
.hero-cal{padding:10rem 0 6rem;background:radial-gradient(ellipse at top right,#eff6ff,transparent 50%),radial-gradient(ellipse at bottom left,#f5f3ff,transparent 50%);}
.badge-cal{display:inline-block;padding:.5rem 1rem;background:#eff6ff;color:#1d4ed8;font-weight:800;font-size:.75rem;border-radius:9999px;margin-bottom:1.5rem;text-transform:uppercase;border:1px solid #bfdbfe;letter-spacing:.05em;}
.hero-title{font-size:clamp(2rem,4vw,3.5rem);font-weight:900;color:#111827;line-height:1.15;margin-bottom:1.25rem;}
.hero-sub{font-size:1.1rem;color:#6b7280;line-height:1.7;margin-bottom:2rem;}
.hero-ctas{display:flex;flex-wrap:wrap;gap:1rem;margin-bottom:2rem;}
.hero-stats{display:flex;flex-wrap:wrap;gap:.75rem;padding-top:1.75rem;border-top:1px solid #f1f5f9;}
.stat-pill{display:flex;flex-direction:column;padding:.65rem 1.15rem;background:white;border:1px solid #e5e7eb;border-radius:9999px;}
.sv{font-size:1rem;font-weight:900;color:#f97316;}
.sl{font-size:.65rem;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.05em;}
/* Cal UI */
.cal-ui{background:white;border-radius:1.5rem;border:1px solid #e5e7eb;overflow:hidden;box-shadow:0 20px 60px -12px rgba(0,0,0,.1);}
.cal-ui-bar{background:#f8fafc;border-bottom:1px solid #e5e7eb;padding:1rem 1.5rem;display:flex;align-items:center;justify-content:space-between;}
.cal-logo{font-size:.9rem;font-weight:900;color:#1e293b;display:flex;align-items:center;gap:.5rem;}
.cal-logo i{color:#f97316;}
.cal-ui-sub{font-size:.72rem;font-weight:700;color:#94a3b8;}
.cal-ui-body{padding:1.25rem;}
/* Steps */
.cal-steps{display:flex;align-items:center;justify-content:center;gap:0;margin-bottom:1.5rem;}
.cs{display:flex;flex-direction:column;align-items:center;gap:.35rem;min-width:60px;}
.cs-num{width:1.75rem;height:1.75rem;border-radius:50%;background:#f1f5f9;color:#94a3b8;font-size:.72rem;font-weight:800;display:flex;align-items:center;justify-content:center;}
.cs span{font-size:.62rem;font-weight:700;color:#94a3b8;text-align:center;}
.cs.cs-done .cs-num{background:#22c55e;color:white;}
.cs.cs-done span{color:#166534;}
.cs.cs-active .cs-num{background:#f97316;color:white;}
.cs.cs-active span{color:#f97316;font-weight:800;}
.cs-line{width:40px;height:2px;background:#e5e7eb;margin-bottom:1.1rem;}
.cs-line.done-line{background:#22c55e;}
/* Calendar grid */
.cal-main{display:grid;grid-template-columns:1fr 1fr;gap:1.25rem;}
.cal-month-nav{display:flex;align-items:center;justify-content:space-between;margin-bottom:.75rem;}
.cal-month-nav span{font-size:.82rem;font-weight:800;color:#1e293b;}
.cmn-btn{width:1.75rem;height:1.75rem;border-radius:.4rem;border:1px solid #e5e7eb;background:white;color:#6b7280;font-size:.7rem;display:flex;align-items:center;justify-content:center;cursor:pointer;}
.cal-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:.25rem;}
.cg-day-head{font-size:.6rem;font-weight:800;color:#94a3b8;text-align:center;padding:.25rem 0;text-transform:uppercase;}
.cg-day{font-size:.75rem;font-weight:700;color:#374151;text-align:center;padding:.4rem .2rem;border-radius:.4rem;cursor:pointer;}
.cg-day.disabled{color:#d1d5db;cursor:default;}
.cg-day.empty{color:transparent;}
.cg-day.selected{background:#f97316;color:white;font-weight:800;}
.cg-day:not(.disabled):not(.empty):not(.selected):hover{background:#eff6ff;}
/* Slots */
.cr-label{font-size:.82rem;font-weight:800;color:#1e293b;margin-bottom:.75rem;}
.cr-slots{display:flex;flex-direction:column;gap:.5rem;margin-bottom:1rem;}
.cr-slot{background:#f8fafc;border:1px solid #e5e7eb;border-radius:.75rem;padding:.75rem 1rem;display:flex;align-items:center;justify-content:space-between;cursor:pointer;}
.cr-slot.available{cursor:pointer;}
.cr-slot.selected-slot{border-color:#f97316;background:#eff6ff;}
.slot-time{font-size:.78rem;font-weight:700;color:#1e293b;}
.slot-time small{display:block;font-size:.65rem;color:#94a3b8;font-weight:600;}
.slot-badge{font-size:.65rem;font-weight:800;padding:.2rem .6rem;border-radius:9999px;}
.slot-badge.avail{background:#f0fdf4;color:#166534;}
.slot-badge.sel-badge{background:#dbeafe;color:#1d4ed8;}
.cr-recap{display:flex;flex-direction:column;gap:.4rem;margin-bottom:1rem;background:#f8fafc;border-radius:.65rem;padding:.75rem;}
.recap-row{display:flex;align-items:center;gap:.6rem;font-size:.72rem;font-weight:700;color:#374151;}
.recap-row i{color:#f97316;font-size:.7rem;}
.cal-confirm-btn{width:100%;background:#f97316;color:white;border:none;padding:.85rem;border-radius:9999px;font-size:.82rem;font-weight:800;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:.5rem;}
/* Trust */
.trust-bar{background:#0f172a;padding:1.25rem 0;}
.trust-items{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;}
.trust-item{display:flex;align-items:center;gap:.6rem;padding:.5rem 2rem;color:#94a3b8;font-size:.8rem;font-weight:700;}
.trust-item i{color:#f97316;}
.trust-sep{width:1px;height:1.25rem;background:#334155;}
/* Sections */
.section-label-cal{display:inline-block;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#f97316;margin-bottom:1rem;}
.section-title{font-size:2.25rem;font-weight:900;color:#111827;line-height:1.2;margin-bottom:1rem;}
.section-sub{font-size:1.05rem;color:#6b7280;line-height:1.7;max-width:38rem;}
/* Steps flow */
.steps-flow{display:flex;align-items:flex-start;justify-content:center;gap:0;flex-wrap:wrap;}
.step-card{background:white;border:1px solid #f1f5f9;border-radius:1.25rem;padding:2rem;width:220px;text-align:center;position:relative;}
.step-num{position:absolute;top:-1rem;left:50%;transform:translateX(-50%);width:2rem;height:2rem;background:#f97316;color:white;border-radius:50%;font-size:.82rem;font-weight:900;display:flex;align-items:center;justify-content:center;}
.step-icon{font-size:1.75rem;color:#f97316;margin:1.25rem 0 1rem;}
.step-card h3{font-size:.95rem;font-weight:800;color:#111827;margin-bottom:.5rem;}
.step-card p{font-size:.82rem;color:#6b7280;line-height:1.6;}
.step-arrow{font-size:1.25rem;color:#d1d5db;padding:4rem .75rem 0;flex-shrink:0;}
@media(max-width:900px){.step-arrow{display:none;}.steps-flow{gap:1.25rem;}}
/* Feats 2col */
.feats-2col{display:grid;grid-template-columns:1fr 1fr;gap:1.5rem;}
@media(max-width:700px){.feats-2col{grid-template-columns:1fr;}}
.feat2{background:white;border:1px solid #f1f5f9;border-radius:1.25rem;padding:2rem;}
.f2-icon{width:2.75rem;height:2.75rem;background:#eff6ff;color:#f97316;border-radius:.75rem;display:flex;align-items:center;justify-content:center;font-size:1.1rem;margin-bottom:1.25rem;}
.feat2 h3{font-size:1rem;font-weight:800;color:#111827;margin-bottom:.75rem;}
.feat2 p{font-size:.9rem;color:#6b7280;line-height:1.65;}
/* Perso */
.perso-items{display:flex;flex-direction:column;gap:.75rem;}
.pi{display:flex;align-items:flex-start;gap:.75rem;font-size:.9rem;color:#374151;}
.pi i{color:#f97316;margin-top:.2rem;flex-shrink:0;}
.perso-preview{background:white;border:1px solid #e5e7eb;border-radius:1.5rem;overflow:hidden;}
.pp-bar{background:#f8fafc;border-bottom:1px solid #e5e7eb;padding:.85rem 1.25rem;display:flex;align-items:center;justify-content:space-between;font-size:.72rem;font-weight:700;color:#64748b;}
.pp-color-swatches{display:flex;gap:.4rem;}
.pp-swatch{width:20px;height:20px;border-radius:50%;cursor:pointer;border:2px solid transparent;}
.pp-swatch.active-swatch{border-color:#1e293b;}
.pp-header{padding:1.5rem;color:white;}
.pp-logo-area{font-size:1rem;font-weight:900;display:flex;align-items:center;gap:.5rem;margin-bottom:.3rem;}
.pp-tagline{font-size:.8rem;opacity:.85;}
.pp-body{padding:1.25rem;}
.pp-welcome{font-size:.85rem;font-weight:700;color:#374151;margin-bottom:1rem;}
.pp-types{display:grid;grid-template-columns:1fr 1fr;gap:.5rem;margin-bottom:1rem;}
.pp-type{background:#f8fafc;border:1px solid #e5e7eb;border-radius:.65rem;padding:.65rem;font-size:.78rem;font-weight:700;color:#374151;text-align:center;cursor:pointer;}
.pp-type.selected-type{background:#fff7ed;border-color:#fed7aa;color:#c2410c;}
.pp-next{color:white;font-weight:800;font-size:.85rem;padding:.75rem;border-radius:9999px;text-align:center;cursor:pointer;}
.pp-note{padding:.85rem 1.25rem;background:#f0fdf4;font-size:.75rem;font-weight:700;color:#166534;display:flex;align-items:center;gap:.5rem;}
/* Buttons */
.btn-primary-cal{background:linear-gradient(to right,#f97316,#c91d1d);color:white;padding:1rem 2.5rem;border-radius:9999px;font-weight:800;border:none;cursor:pointer;font-size:.95rem;}
.btn-primary-large-cal{background:#f97316;color:white;padding:1.2rem 3rem;border-radius:9999px;font-weight:800;border:none;font-size:1.05rem;cursor:pointer;}
.btn-outline-large{border:2px solid #e5e7eb;padding:1rem 2.5rem;border-radius:9999px;font-weight:800;color:#1f2937;text-decoration:none;display:inline-block;}
.btn-outline-dark{border:2px solid #334155;padding:1.2rem 3rem;border-radius:9999px;font-weight:800;color:#94a3b8;text-decoration:none;display:inline-block;}
@media(max-width:1024px){.hero-cal{padding-top:8rem;text-align:center;}.cal-ui{margin-top:3rem;}.section-title{font-size:1.75rem;}.cal-main{grid-template-columns:1fr;}}
</style>